import { BasicTrackingEvent } from "./BasicTrackingEvent";
import * as trackingEvents from "@goodgamestudios/tracking-event-types";

export class FacebookConnectionTrackingEvent extends BasicTrackingEvent {
    public playerId: number;
    public zoneId: number;
    public timestamp: number;
    public facebookExternalState: string;
    public facebookId: string;
    public gameLevel: number;

    constructor(referrer: string) {
        super(referrer);
    }

    public getVars(): trackingEvents.FacebookConnection.Event {
        return {
            eventId: trackingEvents.FacebookConnection.ID,
            facebook_connection_state: this.facebookExternalState,
            game_level: this.gameLevel,
            playerId: this.playerId,
            timestamp: this.timestamp,
            user_external_id: this.facebookId,
        };
    }
}
